import React, { Component } from "react";
import { berRatings } from "../helper/lists.js";
import "./../pages/Calculators.css";
import { Row } from "react-bootstrap";
import { ReactComponent as BERA } from "./SVG/DOD BER A.svg";
import { ReactComponent as BERB } from "./SVG/DOD BER B.svg";
import { ReactComponent as BERC } from "./SVG/DOD BER C.svg";
import { ReactComponent as BERD } from "./SVG/DOD BER D.svg";
import { ReactComponent as BERE } from "./SVG/DOD BER E.svg";
import { ReactComponent as BERF } from "./SVG/DOD BER F.svg";
import { ReactComponent as BERG } from "./SVG/DOD BER G.svg";
import { ReactComponent as BERIDLE } from "./SVG/DOD BER Idle.svg";

interface IProps {
  label?: any;
  ber?: string;
  classes?: string;
  height?: number;
}

export class BerImage extends Component<IProps, any> {
  render() {
    const ratio = 223 / 80; // this was the size of the svgs provided
    return (
      <div className="calc-grid justify-left select">
        <Row>
          {this.props.label && (
            <label className="calculator-labels" htmlFor="ber">
              {this.props.label}
            </label>
          )}
        </Row>
        <div className="text-start">
          {this.props.ber === "A" ? (
            <BERA
              height={this.props.height ?? 50}
              width={(this.props.height ?? 50) * ratio}
            />
          ) : this.props.ber === "B" ? (
            <BERB
              height={this.props.height ?? 50}
              width={(this.props.height ?? 50) * ratio}
            />
          ) : this.props.ber === "C" ? (
            <BERC
              height={this.props.height ?? 50}
              width={(this.props.height ?? 50) * ratio}
            />
          ) : this.props.ber === "D" ? (
            <BERD
              height={this.props.height ?? 50}
              width={(this.props.height ?? 50) * ratio}
            />
          ) : this.props.ber === "E" ? (
            <BERE
              height={this.props.height ?? 50}
              width={(this.props.height ?? 50) * ratio}
            />
          ) : this.props.ber === "F" ? (
            <BERF
              height={this.props.height ?? 50}
              width={(this.props.height ?? 50) * ratio}
            />
          ) : this.props.ber === "G" ? (
            <BERG
              height={this.props.height ?? 50}
              width={(this.props.height ?? 50) * ratio}
            />
          ) : (
            <BERIDLE
              height={this.props.height ?? 50}
              width={(this.props.height ?? 50) * ratio}
            />
          )}
        </div>
      </div>
    );
  }
}
